import { render } from "./index.vue?vue&type=template&id=8c841ca8&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=8c841ca8&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-8c841ca8"

export default script